export default {"src":"/_next/static/media/question-mark-blue.93d330e3.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};